import type { IInvoice } from "../../create/interfaces/invoice.interfaces";

export type InvoiceStatus = "UNPAID" | "PAID" | "REFUNDED" | "CANCELLED";

/**
 * Derives invoice status from timestamps. Order matters: cancelled and refunded are terminal.
 */
export const getInvoiceStatus = (invoice: IInvoice): InvoiceStatus => {
  if (invoice?.cancelledAt) return "CANCELLED";
  if (invoice?.refundedAt) return "REFUNDED";
  if (invoice?.paidAt) return "PAID";
  // Manual entry / webhook may set paid method on root without paidAt in some payloads
  if (invoice?.paidWithPaymentMethod) return "PAID";
  return "UNPAID";
};

export const getInvoiceStatusLabel = (status: InvoiceStatus): string => {
  switch (status) {
    case "UNPAID":
      return "Pending Payment";
    case "PAID":
      return "Paid";
    case "REFUNDED":
      return "Refunded";
    case "CANCELLED":
      return "Cancelled";
    default:
      return status;
  }
};
